
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20.5 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.667 16.858v-1.686a3.381 3.381 0 00-3.371-3.371h-5.9a3.382 3.382 0 00-3.373 3.371v1.686M10.716 5.057A3.382 3.382 0 017.344 8.43a3.382 3.382 0 01-3.371-3.372 3.382 3.382 0 013.371-3.371 3.382 3.382 0 013.372 3.371zM15.352 5.9l4.214 4.215M19.566 5.9l-4.214 4.215","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    